import { Button, Input, InputNumber, message } from "antd";
import React, { useState } from "react";
import instance from "../../../store/actions/instance";
import { withNamespaces } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updateRegisterPOS } from "../../../store/actions/pos";
function RegisterOpening({ t, closeModal }) {
  const dispatch = useDispatch();
  const [floatAmount, setFloatAmount] = useState(0);
  const [openingNote, setOpeningNote] = useState(null);
  const [loading, setLoading] = useState(false);

  const settings = useSelector((state) => state.auth.settings);
  const config = useSelector((state) => state.config);
  const selectedRegister = useSelector((state) => state.pos.selectedRegister);
  const currency =
    (config.langugae === "arabic" && settings.currency_local) ||
    settings.currency_english;
  async function openRegister() {
    try {
      setLoading(true);
      const res = await instance.post(`/open_register/`, {
        registerId: selectedRegister.id,
        floatAmount: floatAmount,
        openingNote: openingNote,
      });
      dispatch(updateRegisterPOS(res.data));
      closeModal?.();
    } catch (err) {
      console.log(err);
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
    setLoading(false);
  }
  return (
    <div
      className="p-4"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 10,

        backgroundColor: "white",

        borderBottom: "1px solid #d9d9d9",
        borderRadius: 6,
        color: "#333333",
      }}
    >
      <h4>{t("Register Closed")}</h4>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          textAlign: "left",
          width: "100%",
        }}
      >
        <p>{t("Opening Float")}</p>
        <InputNumber
          onChange={setFloatAmount}
          value={floatAmount}
          className="w-100"
          placeholder={"0.00"}
          prefix={currency}
          min={0}
        />
      </div>
      <div
        className="w-100"
        style={{ display: "flex", flexDirection: "column", textAlign: "left" }}
      >
        <p>{t("Notes (optional)")}</p>
        <Input.TextArea
          rows={2}
          maxLength={255}
          onChange={(e) => setOpeningNote(e.target.value)}
        />
      </div>

      <Button
        className="mt-3"
        type="primary"
        onClick={openRegister}
        block
        disabled={floatAmount === null}
        loading={loading}
      >
        {t("Open Register")}
      </Button>
    </div>
  );
}

export default withNamespaces()(RegisterOpening);
